<template>
    <eventi-view-component :jsonData="jsonData" :pathResource="pathResource" :pathResourceFirma="pathResourceFirma" :utente="utente" :titoloEvento="titoloEvento" :linkPrintData="linkPrintData">
        <template slot="tab-content-event">
            <cardio-chirurgia-view-component :idEvento="id" @update="onUpdateJsonData"></cardio-chirurgia-view-component>
        </template>
    </eventi-view-component>
</template>
<script>
import UtilityMixins from "../../../../../utility/UtilityMixin";
import CardioChirurgiaViewComponent from "./CardioChirurgiaViewComponent.vue";
import EventiViewComponent from "../../../base/components/EventiViewComponent.vue";
import EventiMixins from "../../../utility/mixins/EventiMixins";
export default {
    mixins: [UtilityMixins, EventiMixins],
    props: {
        utente: {
            type: Object,
            default: function () {
                return null;
            },
        },
    },
    components: { CardioChirurgiaViewComponent, EventiViewComponent },
    data() {
        return {
            titoloEvento: "Cardiochirurgia",
            linkback: null,
            pathResource: "/cardiochirurgia",
            pathResourceFirma: "/cardiochirurgia",
            jsonData: {},
            id: null,
            linkPrintData: null,
            tabIndex: 0,
            showModalLoading: false,
            fontScale: 2,
            linkedit: null,
            pathRestValidation: "/validation",
            isThisFirmato: false,
        };
    },
    computed: {
        idPaziente() {
            return this.$route.query.idPaziente;
        },
        linkPatient() {
            return EventiMixins.getLinkPatient(this.utente, this.idPaziente);
        },
    },
    mounted() {
        let me = this;
        me.jsonData.idPaziente = this.$route.query.idPaziente;
        me.id = this.$route.params.id;
    },
    methods: {
        updateStatoFirma(firmato) {
            console.log(firmato);
        },
        onUpdateJsonData(data) {
            let me = this;
            me.jsonData = data;
            me.linkPrintData = "/pazienteeventi/print/" + me.jsonData.id;
        },
    },
};
</script>
